import angular from 'angular';
import {
  userService,
  ssDialogService,
  riskDataService,
  riskSharedModelService,
  controlDataService,
  controlSharedModelService,
} from 'app/services';
import {
  confirmDialog,
  alerts,
  actionIcon
} from 'app/components/global';
import editRiskDialog from '../dialog.editRiskDialog';
import controller from './risk-main.controller';
import directive from './risk-main.directive';
import risk from '../risk';
import bulkDeleteRisksDialog from '../dialog.bulkDeleteRisksDialog';
import syncRiskTypeDialog from '../dialog.syncRiskTypeDialog';


const riskModule = angular.module('app.components.admin.riskMain', [
  userService,
  alerts,
  actionIcon,
  confirmDialog,
  editRiskDialog,
  ssDialogService,
  riskDataService,
  riskSharedModelService,
  controlDataService,
  controlSharedModelService,
  risk,
  bulkDeleteRisksDialog,
  syncRiskTypeDialog,
])
  .directive('riskMain', directive)
  .controller('RiskMainController', controller);

export default riskModule.name;

console.log('app.components.admin.riskMain created');
